// extracted by mini-css-extract-plugin
export default {"SubMenu":"SubMenu_SubMenu__o+Usl"};